export const ClinicStatus = {
    published: 'published',
    ready: 'ready',
    inactive: 'inactive',
    active: 'active',
    setup: 'setup',
    reviewing: 'reviewing'
}

export const ClinicStatusColor = {
    published: 'bg-green-100 text-green-800',
    ready: 'bg-blue-100 text-blue-800',
    inactive: 'bg-red-100 text-red-800',
    active: 'bg-gray-100 text-gray-800',
    setup: 'bg-yellow-100 text-yellow-800',
    reviewing: 'bg-purple-100 text-purple-800'
}
